import React from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import s from './BookingDetailsPage.module.scss';

const CartReviewStep = ({
                            cartItems,
                            quote,
                            onRemove,
                            onCheckout
                        }) => {
    return (
        <div className={s.review}>
            <Typography variant="h5">
                カート内容確認
            </Typography>

            {cartItems.map((item, idx) => (
                <div key={idx} className={s.cartCard}>
                    <div>
                        <h4>{item.productName}</h4>
                        <div>{item.date}</div>
                    </div>

                    <Button
                        color="error"
                        onClick={() => onRemove(idx)}
                    >
                        削除
                    </Button>
                </div>
            ))}

            <div className={s.grandTotal}>
                合計: ${quote?.total?.toFixed(2)}
            </div>

            <Button
                variant="contained"
                onClick={onCheckout}
            >
                支払いへ進む
            </Button>
        </div>
    );
};

export default CartReviewStep;